import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { getCurrentContentTypeFromURL } from '../../../features/divestitureDiagnostic/divestitureDiagnosticSlice';
import { CONTENT_TYPE_RESULTS } from '../../../features/divestitureDiagnostic/routes';
import Response from '../Response/Response';

import './ResponseSection.scss';

const ResponseSection = ({ section }) => {
  const { sectionTitle, questions, sectionPath } = section;
  const contentType = useSelector(getCurrentContentTypeFromURL);

  const isResultsRoute = contentType === CONTENT_TYPE_RESULTS;

  return (
    <div className="response-section-container">
      <table>
        <thead>
          <tr>
            <th>{sectionTitle}</th>
            {!isResultsRoute && (
              <th className="response-section-button-header">
                <Link to={sectionPath} className="ui-button button-outline">
                  Amend
                </Link>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {questions.map((question) => (
            <Response key={question.id} question={question} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResponseSection;
